module.exports = __webpack_public_path__ + "img/exercise-dumbbell.590722ae.png";